<template>
  <b-row>
    <b-col md="8">
      <b-card>
        <b-form v-on:submit.prevent>
          <b-row>
            <b-col cols="12" class="text-left mb-2">
              <b-badge :variant="statusVariant(form.status)">
                <span class="text-nowrap" v-if="form.status === 1"
                  >Waiting Confirmation</span
                >
                <span class="text-nowrap" v-else-if="form.status === 2">
                  <span class="text-nowrap" v-if="form.status_process === 0"
                    >Waiting Picking Process</span
                  >
                  <span
                    class="text-nowrap"
                    v-else-if="form.status_process === 1"
                    >Picking Process</span
                  >
                  <span
                    class="text-nowrap"
                    v-else-if="form.status_process === 2"
                    >Waiting Checking Process</span
                  >
                  <span
                    class="text-nowrap"
                    v-else-if="form.status_process === 3"
                    >Checking Process</span
                  >
                  <span
                    class="text-nowrap"
                    v-else-if="form.status_process === 4"
                    >Waiting Packing Process</span
                  >
                  <span
                    class="text-nowrap"
                    v-else-if="form.status_process === 5"
                    >Packing Process</span
                  >
                  <span
                    class="text-nowrap"
                    v-else-if="form.status_process === 6"
                    >Finished</span
                  >
                </span>
                <span class="text-nowrap" v-else-if="form.status === 3"
                  >Rejected</span
                >
              </b-badge>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col md="6"> Code </b-col>
                <b-col md="6" class="text-right font-weight-bolder">
                  {{ form.code }}
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col md="6"> Order Code </b-col>
                <b-col md="6" class="text-right font-weight-bolder">
                  {{ form.order_code }}
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col md="6"> Date </b-col>
                <b-col md="6" class="text-right font-weight-bolder">
                  {{ moment(form.created_at) }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
              class="mt-3"
              v-if="
                permissions.includes('warehouse-fulfillment-approval') &&
                form.status === 1
              "
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                class="mr-1"
                @click="confirm()"
                block
              >
                Confirm
              </b-button>
            </b-col>
            <b-col
              md="6"
              class="mt-3"
              v-if="
                permissions.includes('warehouse-fulfillment-approval') &&
                form.status === 1
              "
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="danger"
                class="mr-1"
                v-b-modal.modal-reject
                block
              >
                Reject
              </b-button>
            </b-col>
            <!-- modal reject -->
            <b-modal
              id="modal-reject"
              title="Reject Form"
              ok-title="Reject"
              cancel-variant="outline-secondary"
              hide-footer
            >
              <validation-observer ref="loginValidation">
                <b-form ref="form" @submit.prevent>
                  <b-form-group
                    :state="errors"
                    label="Reject Reason"
                    label-for="reject"
                    invalid-feedback="Reject Reason required"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="reject"
                      rules="required"
                    >
                      <b-form-input
                        id="reject"
                        name="reject"
                        type="text"
                        v-model="reject_reason"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Reject Reason"
                        required="required"
                      />
                      <small class="text-danger">{{
                        errors[0] || errMessage
                      }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-row>
                    <b-col>
                      <b-button
                        class="mt-3"
                        type="submit"
                        variant="danger"
                        block
                        @click="reject()"
                      >
                        Reject
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-modal>
            <!-- end modal reject -->
            <b-col
              md="12"
              class="mt-3"
              v-if="
                permissions.includes('warehouse-fulfillment-update') &&
                form.status === 2 &&
                form.status_process === 0
              "
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="confirmationPicking()"
                block
              >
                Confirmation Picking
              </b-button>
            </b-col>
            <b-col
              md="12"
              class="mt-3"
              v-if="
                permissions.includes('warehouse-fulfillment-update') &&
                form.status_process === 1
              "
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="finishPicking()"
                block
              >
                Finish Picking
              </b-button>
            </b-col>
            <b-col
              md="12"
              class="mt-3"
              v-if="
                permissions.includes('warehouse-fulfillment-update') &&
                form.status_process === 2
              "
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="confirmationChecking()"
                block
              >
                Confirmation Checking
              </b-button>
            </b-col>
            <b-col
              md="12"
              class="mt-3"
              v-if="
                permissions.includes('warehouse-fulfillment-update') &&
                form.status_process === 3
              "
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="finishChecking()"
                block
              >
                Finish Checking
              </b-button>
            </b-col>
            <b-col
              md="12"
              class="mt-3"
              v-if="
                permissions.includes('warehouse-fulfillment-update') &&
                form.status_process === 4
              "
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="confirmationPacking()"
                block
              >
                Confirmation Packing
              </b-button>
            </b-col>
            <b-col
              md="12"
              class="mt-3"
              v-if="
                permissions.includes('warehouse-fulfillment-update') &&
                form.status_process === 5
              "
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="finishPacking()"
                block
              >
                Finish Packing
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
      <b-card>
        <label class="font-weight-bolder text-primary mb-1" for="product"
          >List Items</label
        >
        <b-row class="mb-1" v-for="(product, list) in items" :key="list">
          <b-col cols="12">
            <b-row>
              <b-col cols="12" md="12">
                <b-img
                  thumbnail
                  fluid
                  :src="product.image"
                  width="150"
                  class="float-left mr-1"
                />
                <b-row>
                  <b-col md="12">
                    <div class="mb-2 font-weight-bolder">
                      {{ product.code }}
                    </div>
                    <div class="text-success font-weight-bolder">
                      {{ product.name }} ({{ product.category }}})
                    </div>
                    <div>
                      {{ product.qty }} {{ product.unit }} X
                      {{ formatRupiah(product.price) }}
                      <span class="float-right text-primary font-weight-bold">{{
                        formatRupiah(product.total_price)
                      }}</span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col md="4">
      <b-card>
        <b-form v-on:submit.prevent>
          <b-row>
            <b-col md="12">
              <label for="history" class="text-primary font-weight-bolder mb-1"
                >History</label
              >
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col md="6"> Picked By </b-col>
                <b-col
                  md="6"
                  class="text-right font-weight-bolder"
                  v-if="form.picked_name === ''"
                >
                  -
                </b-col>
                <b-col md="6" class="text-right font-weight-bolder" v-else>
                  {{ form.picked_name }}
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col md="6"> Checked By </b-col>
                <b-col
                  md="6"
                  class="text-right font-weight-bolder"
                  v-if="form.checked_name === ''"
                >
                  -
                </b-col>
                <b-col md="6" class="text-right font-weight-bolder" v-else>
                  {{ form.checked_name }}
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col md="6"> Packed By </b-col>
                <b-col
                  md="6"
                  class="text-right font-weight-bolder"
                  v-if="form.packed_name === ''"
                >
                  -
                </b-col>
                <b-col md="6" class="text-right font-weight-bolder" v-else>
                  {{ form.packed_name }}
                </b-col>
              </b-row>
              <hr v-if="form.reject_reason !== ''" />
              <b-row v-if="form.reject_reason !== ''">
                <b-col md="6"> Reject Reason </b-col>
                <b-col md="6" class="text-right font-weight-bolder">
                  {{ form.reject_reason }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BImg,
  BContainer,
  BBadge,
  BFormTextarea,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import { $themeConfig } from "@themeConfig";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    BImg,
    BContainer,
    BBadge,
    BFormTextarea,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        code: "",
        order_code: "",
        purchase_price: null,
        tax: null,
        shipping_cost: null,
        discount: null,
        gross_price: null,
        picked_name: "",
        checked_name: "",
        packed_name: "",
        reject_reason: "",
        status: null,
        status_process: null,
        created_at: "",
      },
      permissions: [],
      reject_reason: "",
      items: [],
      errors: "",
      errMessage: "",
    };
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        1: "light-warning",
        2: "light-success",
        3: "light-danger",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    this.getAllPermissions();
    this.getDetails();
    this.getDetailItems();
  },
  methods: {
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    moment(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm");
    },
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("warehouse/fulfillment/" + id).then((response) => {
        // console.log(response.data.data)
        this.form.code = response.data.data.code;
        this.form.order_code = response.data.data.order_code;
        this.form.purchase_price = response.data.data.purchase_price;
        this.form.tax = response.data.data.tax;
        this.form.discount = response.data.data.discount;
        this.form.gross_price = response.data.data.gross_price;
        this.form.shipping_cost = response.data.data.shipping_cost;
        this.form.picked_name = response.data.data.picked_by_name;
        this.form.checked_name = response.data.data.checked_by_name;
        this.form.packed_name = response.data.data.packed_by_name;
        this.form.reject_reason = response.data.data.reject_reason;
        this.form.status = response.data.data.status;
        this.form.status_process = response.data.data.status_process;
        this.form.created_at = response.data.data.created_at;
      });
    },
    getDetailItems() {
      const id = this.$route.params.id;
      this.$http
        .get("warehouse/fulfillment/" + id + "/items")
        .then((response) => {
          // console.log(response.data.data)
          const { baseUrl } = $themeConfig.app;
          this.url = baseUrl;
          this.url += "storage/product/";

          var datas = response.data.data;
          var i;
          for (i = 0; i < datas.length; i++) {
            var $data = {
              category: datas[i].category,
              code: datas[i].code,
              id: datas[i].id,
              image: this.url + datas[i].image,
              name: datas[i].name,
              price: datas[i].price,
              product_id: datas[i].product_id,
              qty: datas[i].qty,
              quotation_id: datas[i].quotation_id,
              total_price: datas[i].total_price,
              unit: datas[i].unit,
            };
            this.items.push($data);
          }
          // console.log(this.items)
        });
    },
    confirm() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/fulfillment/" + id + "/confirm")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Confirmed",
              variant: "success",
            },
          });
          location.href = "/warehouse/fulfillment-request";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    reject() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/fulfillment/" + id + "/reject", {
          reject_reason: this.reject_reason,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Rejected",
              variant: "danger",
            },
          });
          location.href = "/warehouse/fulfillment-request";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    confirmationPicking() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/fulfillment/" + id + "/status", {
          status: 1,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Confirmation Picking",
              variant: "success",
            },
          });
          location.href = "/warehouse/fulfillment-request";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    finishPicking() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/fulfillment/" + id + "/status", {
          status: 2,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Finish Picking",
              variant: "success",
            },
          });
          location.href = "/warehouse/fulfillment-request";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    confirmationChecking() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/fulfillment/" + id + "/status", {
          status: 3,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Confirmation Checking",
              variant: "success",
            },
          });
          location.href = "/warehouse/fulfillment-request";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    finishChecking() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/fulfillment/" + id + "/status", {
          status: 4,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Finish Checking",
              variant: "success",
            },
          });
          location.href = "/warehouse/fulfillment-request";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    confirmationPacking() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/fulfillment/" + id + "/status", {
          status: 5,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Confirmation Packing",
              variant: "success",
            },
          });
          location.href = "/warehouse/fulfillment-request";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    finishPacking() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/fulfillment/" + id + "/status", {
          status: 6,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Finish Packing",
              variant: "success",
            },
          });
          location.href = "/warehouse/fulfillment-request";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>